module.exports = __webpack_public_path__ + "81190c83fef611278cbd20f7102bfcc1.png";


//////////////////
// WEBPACK FOOTER
// ./images/slide2.png
// module id = 672
// module chunks = 0